import { IDomesticInsuranceInitialValues } from '../../../types';

export const INITIAL_VALUES: IDomesticInsuranceInitialValues = {
  id: undefined,
  upload_files: [],
  recent_status: '',
  organization: 0,
  policy_number: undefined,
  start_date: '',
  end_date: '',
  description: '',
  email_users: [],
  type: '',
  branch: '',
};
